export const maxCategoryDepth = 2;
